import { Dictionary } from "@/lib/Dictionary.type";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import FactorySettings from "./factory-settings.model";

export default class FactorySettingsRepository extends BasicRepository<FactorySettings> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<FactorySettings>,
    responseParser: ApiCollectionResponseParserService<FactorySettings>
  ) {
    super("factory_settings", api, objectBuilder, responseParser);
  }

  protected prepareData(item: FactorySettings): Dictionary<boolean> {
    return { earlyArtworkAccessEnabled: item.isEarlyArtworkAccessEnabled };
  }
}
